<template lang='pug'>
EventToProp(
  v-slot='{ prop: food_id, updateProp: food_id_update, timestamp: food_id_timestamp }'
)
  FormBarcode(
    :barcodeInitial='$store.state.settings.barcode'
    @update:barcode='barcode => $store.commit("barcode_update", barcode)'
    @update:food_id='food_id_update'
  )
  FoodGetV2(
    v-if='food_id'
    :key='food_id_timestamp'
    :food_id='food_id'
  )
</template>

<script>
import { FormBarcode } from '@thomasphan/vue-components/src/index';
import { FoodGetV2 } from '@thomasphan/vue-components/src/index';

import EventToProp from '@thomasphan/vue-components/src/components/EventToProp.vue';

export default
{
  components:
  {
    EventToProp,
    FormBarcode,
    FoodGetV2,
  }
};
</script>